import React from 'react';

export const ChevronDown = () => (
    <path d='M23.832,5.126c-0.205-0.184-0.522-0.165-0.706,0.043L12,17.745L0.875,5.169c-0.183-0.209-0.5-0.228-0.706-0.043
		c-0.207,0.183-0.227,0.498-0.043,0.705l11.5,13C11.721,18.938,11.857,19,12,19s0.28-0.062,0.375-0.169l11.5-13
		C24.058,5.624,24.039,5.309,23.832,5.126z' />
);